export const HOME_ACTION_KEYS = [
  'link',
  'reupload',
  'html-custom-domain',
  'mufy',
  'extract',
  'processing',
  'edit',
  'access',
  'qr-code',
  'short-url',
  'more',
  'link.original',
  'link.compressed',
  'link.overseas',
  'link.encrypted',
  'processing.ai-edit',
  'processing.format-encoding',
  'processing.base64',
  'processing.webp',
  'processing.thumbnails',
  'processing.thumbnail-100',
  'processing.thumbnail-200',
  'processing.thumbnail-300',
  'processing.thumbnail-600',
  'processing.watermarks',
  'processing.watermark-default',
  'processing.watermark-tile',
  'processing.watermark-southeast',
  'processing.image-watermark',
  'edit.source',
  'edit.visual',
  'more.remark',
  'more.html-share',
  'more.markdown',
  'more.move-directory',
  'more.switch-domain',
  'more.custom-preview',
] as const;

export type HomeActionKey = typeof HOME_ACTION_KEYS[number];

export const HOME_ACTION_PARENTS: Partial<Record<HomeActionKey, HomeActionKey[]>> = {
  'link.original': ['link'],
  'link.compressed': ['link'],
  'link.overseas': ['link'],
  'link.encrypted': ['link'],
  'processing.ai-edit': ['processing'],
  'processing.format-encoding': ['processing'],
  'processing.base64': ['processing', 'processing.format-encoding'],
  'processing.webp': ['processing', 'processing.format-encoding'],
  'processing.thumbnails': ['processing'],
  'processing.thumbnail-100': ['processing', 'processing.thumbnails'],
  'processing.thumbnail-200': ['processing', 'processing.thumbnails'],
  'processing.thumbnail-300': ['processing', 'processing.thumbnails'],
  'processing.thumbnail-600': ['processing', 'processing.thumbnails'],
  'processing.watermarks': ['processing'],
  'processing.watermark-default': ['processing', 'processing.watermarks'],
  'processing.watermark-tile': ['processing', 'processing.watermarks'],
  'processing.watermark-southeast': ['processing', 'processing.watermarks'],
  'processing.image-watermark': ['processing', 'processing.watermarks'],
  'edit.source': ['edit'],
  'edit.visual': ['edit'],
  'more.remark': ['more'],
  'more.html-share': ['more'],
  'more.markdown': ['more'],
  'more.move-directory': ['more'],
  'more.switch-domain': ['more'],
  'more.custom-preview': ['more'],
};

interface HomeActionHighlightConfig {
  enabled?: boolean;
  actionKeys?: unknown;
}

const supportedActionKeys = new Set<string>(HOME_ACTION_KEYS);

export const loadHomeActionHighlightKeys = async (): Promise<HomeActionKey[]> => {
  try {
    const response = await fetch('/img/home-action-highlight/config');
    if (!response.ok) {
      return [];
    }
    const config = await response.json() as HomeActionHighlightConfig;
    if (config?.enabled !== true || !Array.isArray(config.actionKeys)) {
      return [];
    }
    return Array.from(new Set(
      config.actionKeys.filter(
        (actionKey): actionKey is HomeActionKey =>
          typeof actionKey === 'string' && supportedActionKeys.has(actionKey)
      )
    ));
  } catch {
    return [];
  }
};
